// Pure, dependency-free decision for the gate signup buttons (shipped to everyone after
// post_signup_onboarding_v1 won). Kept free of runtime
// imports so it runs under `node --test` (see signup_cta.test.ts).

/** Gate surfaces whose signup button goes through the full /signup flow. Mid-task flows are not listed. */
export type SignupCtaSurface =
  | 'locked_guide_gate'
  | 'experience_gate'
  | 'take_home_gate'
  | 'cross_user_solution';

export type SignupCtaInput = {
  isBot: boolean;
  /** Path (plus query) of the page the visitor is on. */
  currentPath: string;
  /** Public origin of the legacy app, which fronts /signup and /pricing. */
  frontendUrl: string;
};

export type SignupCtaAction = {kind: 'inline'} | {kind: 'redirect'; href: string};

/**
 * The full /signup flow ending on pricing, which can send the visitor back here after a
 * purchase: /signup?next=/pricing?next=<currentPath>, each level URL-encoded.
 */
export function signupThenPricingHref(frontendUrl: string, currentPath: string): string {
  const pricing = `/pricing?next=${encodeURIComponent(currentPath)}`;
  return `${frontendUrl}/signup?next=${encodeURIComponent(pricing)}`;
}

/**
 * What a gate's signup button does. Everyone goes through the full /signup flow and on to
 * pricing; bots keep the inline AuthForm so they never pollute the signup funnel.
 */
export function signupCtaAction(input: SignupCtaInput): SignupCtaAction {
  if (input.isBot) return {kind: 'inline'};
  return {kind: 'redirect', href: signupThenPricingHref(input.frontendUrl, input.currentPath)};
}
